import Vue from 'vue'
import lazySrc from './lazySrc.js'
import lazyFunc from './lazyFunc.js'
import skeleton from './skeleton.js'
import realImg from  './realImg.js'
Vue.use(lazySrc);
Vue.use(lazyFunc);
Vue.use(skeleton);
Vue.use(realImg);